import React, {useEffect} from "react"
import {
    Button,
    CardContent,
    Card,
    Grid,
    Typography,
    Select, MenuItem, Slider, CircularProgress, Snackbar
} from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import 'react-dropdown/style.css';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import {MAIN_COLOR_BLUE} from "../utils/styles";
import {useTranslation} from "react-i18next";
import {resetCalculation, sendDataToBackend, sendEventsData} from "../store/actions/actions";
import {useAppDispatch, useAppSelector} from "../store/store";
import MuiAlert from '@mui/material/Alert';
import CardInfoButton from "../components/CardInfoButton";
import {useNavigate} from "react-router-dom";
const cities = require("../data/cities.json")
const svf = require("../data/sky_view_factor.json")
const soilTypes = require("../data/soil_types.json")
const species = require("../data/tree_species.json")
const period = require("../data/period.json")
const SendRequestForm = () => {
    const {t, i18n} = useTranslation()
    const [snackbarOpen, setSnackBarOpen] = React.useState(false);
    const [city, setCity] = React.useState('');
    const [treeSpecies, setTreeSpecies] = React.useState('');
    const [treeSize, setTreeSize] = React.useState(30)
    const [soilType, setSoilType] = React.useState('');
    const [soilSealing, setSoilSealing] = React.useState(45)
    const [skyViewFactor, setSkyViewFactor] = React.useState('');
    const [periodData, setPeriodData] = React.useState('')
    const navigate = useNavigate();
    const dispatch = useAppDispatch();


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarOpen(false);
    }

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
    const handleCityChange = (event ) => {
        setCity(event.target.value  );
    };
    const handleTreeSpeciesChange = (event ) => {
        setTreeSpecies(event.target.value  );
    };

    const handleTreeSize = (event ) => {
        setTreeSize(event.target.value);
    };

    const handleSoilType = (event ) => {
        setSoilType(event.target.value  );
    };
    const handleSoilSealing = (event ) => {
        setSoilSealing(event.target.value  );
    };
    const handleSkyViewFactor = (event ) => {
        setSkyViewFactor(event.target.value  );
    };
    const handlePeriod = (event) =>{
        setPeriodData(event.target.value)
    }
    const createCityItems = () => {
        let component  = []
        let language = i18n.language
        let key;
        if(language && language.includes("-")){
            key = language.split("-")[0]
        }
        else{
            key=language
        }
        if(cities && key){
            cities[key].sort((a, b) => a.name > b.name ? 1 : -1).forEach((city) => {
                component.push(
                    <MenuItem key={city.id} value={city.id}>{city.name}</MenuItem>
                )
            });
        }
        return component
    }
    const createSVFItems = () => {
        let component  = []
        let language = i18n.language
        let key
        if(language && language.includes("-")){
            key = language.split("-")[0]
        }
        else{
            key=language
        }
        if(svf && key){
            svf[key].forEach((s) => {
                component.push(
                    <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                )
            })
        }
        return component
    }
    const createSoilItems = () => {
        let component  = []
        let language = i18n.language
        let key
        if(language && language.includes("-")){
            key = language.split("-")[0]
        }
        else{
            key=language
        }
        if(soilTypes && key){
            soilTypes[key].forEach((s ) => {
                component.push(
                    <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                )
            })
        }
        return component
    }
    const createSpecies = () => {
        let component  = []
        let language = i18n.language
        let key
        if(language && language.includes("-")){
            key = language.split("-")[0]
        }
        else{
            key=language
        }
        if(species && key){
            species[key].sort((a, b) => a.name > b.name ? 1 : -1).forEach((s ) => {
                if(s["calculation"] === "true")
                component.push(
                    <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                )
            })
        }
        return component
    }
    const createPeriod = () =>{
        let component  = []
        let language = i18n.language
        let key
        if(language && language.includes("-")){
            key = language.split("-")[0]
        }
        else{
            key=language
        }
        if(period && key){
            period[key].forEach((p ) => {
                component.push(
                    <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
                )
            })
        }
        return component
    }

    function valuetext(value) {
        return `${value} cm`;
    }
    const startCalculation = () => {
        if(city && treeSpecies && soilType ){
            localStorage.removeItem("tum_leitfaden_input")
            localStorage.removeItem("tum_leitfaden_result")
            dispatch(resetCalculation())
            const selectedCity = cities.de.filter((c)=> c.id === Number(city))[0]
            const selectedSoilType = soilTypes.de.filter((s) => s.id === soilType)[0]
            const selectedPeriod = period.de.filter((p) => p.id === periodData)[0]
            const selectedSVF = svf.de.filter((s) => s.id === Number(skyViewFactor))[0]
            const data = {
                city_id: selectedCity.id,
                city: selectedCity.name,
                city_lat: selectedCity.lat,
                city_lng: selectedCity.lng,
                tree_species: treeSpecies,
                tree_size: treeSize,
                soil_type_id: selectedSoilType.id,
                soil_type: selectedSoilType.name,
                field_capacity: selectedSoilType["field_capacity"],
                wilting_point: selectedSoilType["wilting_point"],
                soil_sealing: soilSealing,
                svf_id: selectedSVF.id,
                svf_e: selectedSVF.svf_e,
                svf_s: selectedSVF.svf_s,
                svf_w: selectedSVF.svf_w,
                svf_n: selectedSVF.svf_n,
                period:selectedPeriod.value,
                co2_concentration: selectedPeriod.co2_concentration
            }
            dispatch(sendDataToBackend(data))

            dispatch(sendEventsData({
                date: new Date().toLocaleString(),
                timestamp: new Date().getTime(),
                value: 1,
                type:"simulation-start"
            }))
        }
        else{
            setSnackBarOpen(true)
        }
    }
    const marksTreeSize = [
        {
            value: 10,
            label: ' <10 cm',
        },
        {
            value: 100,
            label: '100 cm',
        },
    ];
    const marksSoilSealing = [
        {
            value: 0,
            label: '0%'
        },
        {
            value: 95,
            label: "> 95%"
        }
    ]

    const start = useAppSelector((state ) => state.app.start)
    const success = useAppSelector((state) => state.app.success);
    const error = useAppSelector((state) => state.app.error)
    const errorMessage = useAppSelector((state) => state.app.errorMessage)
    useEffect(() => {
        if(success){
            window.open("/result","_blank" )
        }
    }, [success,navigate]);

    return (
        <React.Fragment>
            <Grid container rowSpacing={1} columnSpacing={4}>
                <Grid item style={{padding: 4}} xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Card variant="outlined">
                        <CardInfoButton text={t('simulation_page.city_type_description_short')}
                                        link={"/info"} type="city"
                        />
                        <CardContent style={{textAlign: "center"}}>
                            <img alt={t('city')} width={48} height={48}
                                 src={require("../assets/pages/info/icons/stadt.png")}/>
                            <Typography variant="h5" color="text.secondary" gutterBottom>
                                {t('simulation_page.city')}
                            </Typography>

                            <FormControl fullWidth>
                                <InputLabel id="select-label">{t('simulation_page.city')}</InputLabel>
                                <Select
                                    labelId="select-label"
                                    id="simple-select"
                                    value={city || ''}
                                    label={t('city')}
                                    onChange={handleCityChange}
                                >
                                    {cities && createCityItems()}
                                </Select>
                            </FormControl>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item style={{padding: 4}} xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Card variant="outlined">
                        <CardInfoButton text={t('simulation_page.tree_type_description')} link={"/info"} type="tree"/>
                        <CardContent style={{textAlign: "center"}}>
                            <img alt={t('simulation_page.tree_species')} width={48} height={48}
                                 src={require("../assets/pages/info/icons/baumart.png")}/>
                            <Typography variant="h5" color="text.secondary" gutterBottom>
                                {t('simulation_page.tree_species')}
                            </Typography>

                            <FormControl fullWidth>
                                <InputLabel id="select-label">{t('simulation_page.tree_species')}</InputLabel>
                                <Select
                                    labelId="select-label"
                                    id="simple-select"
                                    value={treeSpecies || ''}
                                    label={t('simulation_page.tree_species')}
                                    onChange={handleTreeSpeciesChange}
                                >
                                    {species && createSpecies()}
                                </Select>
                            </FormControl>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item style={{padding: 4}} xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Card variant="outlined">
                        <CardInfoButton text={t('simulation_page.tree_size_description')} link={"/info"} type="tree_size"/>
                        <CardContent style={{textAlign: "center"}}>
                            <img alt={t('simulation_page.tree_size')} width={48} height={48}
                                 src={require("../assets/pages/info/icons/durchmesser.png")}/>
                            <Typography variant="h5" color="text.secondary" gutterBottom>
                                {t('simulation_page.tree_size')}
                            </Typography>
                            <Slider
                                style={{width: "80%"}}
                                aria-label={t('simulation_page.tree_size')}
                                defaultValue={30}
                                getAriaValueText={valuetext}
                                valueLabelDisplay="auto"
                                onChange={handleTreeSize}
                                step={10}
                                marks={marksTreeSize}
                                min={10}
                                max={100}
                            />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container rowSpacing={1} columnSpacing={4}>
            <Grid item xs={12} style={{padding: 4}} sm={12} md={4} lg={4} xl={4}>
                    <Card variant="outlined">
                        <CardInfoButton text={t('simulation_page.soil_type_description')}
                                        link={"/info"} type="soil_type"
                        />
                        <CardContent style={{textAlign: "center"}}>
                            <img alt={t('simulation_page.soil_type')} width={48} height={48}
                                 src={require("../assets/pages/info/icons/bodenart.png")}/>
                            <Typography variant="h5" color="text.secondary" gutterBottom>
                                {t('simulation_page.soil_type')}
                            </Typography>

                            <FormControl fullWidth>
                                <InputLabel id="select-label"> {t('simulation_page.soil_type')}</InputLabel>
                                <Select
                                    labelId="select-label"
                                    id="simple-select"
                                    value={soilType || ''}
                                    label={t('simulation_page.soil_type')}
                                    onChange={handleSoilType}
                                >
                                    {soilTypes && createSoilItems()}
                                </Select>
                            </FormControl>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} style={{padding: 4}} sm={12} md={4} lg={4} xl={4}>
                <Card variant="outlined">
                        <CardInfoButton text={t('simulation_page.soil_sealing_description')}
                                        link={"/info"} type="soil_sealing"
                        />
                    <CardContent style={{textAlign: "center"}}>
                        <img alt={t('simulation_page.soil_sealing')} width={48} height={48}
                             src={require("../assets/pages/info/icons/bodenversiegelung.png")}/>
                        <Typography variant="h5" color="text.secondary" gutterBottom>
                            {t('simulation_page.soil_sealing')}
                        </Typography>

                        <Slider
                            style={{width: "95%"}}
                            aria-label={t('simulation_page.soil_sealing')}
                            onChange={handleSoilSealing}
                            defaultValue={45}
                            getAriaValueText={valuetext}
                            valueLabelDisplay="auto"
                            step={5}
                            marks={marksSoilSealing}
                            min={0}
                            max={95}
                        />
                    </CardContent>
                </Card>
                </Grid>
                <Grid item xs={12} style={{padding: 4}} sm={12} md={4} lg={4} xl={4}>
                <Card variant="outlined">
                        <CardInfoButton text={t('simulation_page.sky_view_factor_description')}
                                        link={"/info"} type="sky_view_factor"
                        />
                        <CardContent style={{textAlign: "center"}}>
                            <img alt={t('simulation_page.sky_view_factor')} width={48} height={48}
                                 src={require("../assets/pages/info/icons/horizont.png")}/>
                            <Typography variant="h5" color="text.secondary" gutterBottom>
                                {t('simulation_page.sky_view_factor')}
                            </Typography>

                            <FormControl fullWidth>
                                <InputLabel id="select-label">{t('simulation_page.sky_view_factor')}</InputLabel>
                                <Select
                                    labelId="select-label"
                                    id="simple-select"
                                    value={skyViewFactor === '' ? '' : skyViewFactor}
                                    label={t('simulation_page.sky_view_factor')}
                                    onChange={handleSkyViewFactor}
                                >
                                    {svf && createSVFItems()}
                                </Select>
                            </FormControl>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid container justifyContent="center">
                    <Grid item xs={12} style={{padding: 4}} sm={12} xl={6}>
                        <Card variant="outlined">
                            <CardInfoButton text={t('simulation_page.period_description')}
                                            link={"/info"} type="period"
                            />
                            <CardContent style={{textAlign: "center"}}>
                                <img alt={t('simulation_page.period')} width={48} height={48}
                                     src={require("../assets/pages/info/icons/zeitraum.png")}/>
                                <Typography variant="h5" color="text.secondary" gutterBottom>
                                    {t('simulation_page.period')}
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel id="select-label">{t('simulation_page.period')}</InputLabel>
                                    <Select
                                        labelId="select-label"
                                        id="simple-select"
                                        value={periodData || ''}
                                        label={t('simulation_page.period')}
                                        onChange={handlePeriod}
                                    >
                                        {period && createPeriod()}
                                    </Select>
                                </FormControl>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                <Grid container justifyContent="flex-end">
                    <Button
                        disableRipple={true}
                        sx={{
                            backgroundColor: MAIN_COLOR_BLUE,
                            color: "white",
                            fontSize: "14px",
                            fontWeight: "bold",
                            padding: "10px 20px",
                            marginTop: "10px",
                            marginRight: "20px",
                            '&:hover': {
                                background: MAIN_COLOR_BLUE
                            },
                        }}
                        onClick={startCalculation}
                    >
                        <PlayCircleOutlineIcon sx={{mr: "10px"}}/>
                        {t('simulation_page.start')}
                    </Button>
                    {
                        start && <CircularProgress/>
                    }
                </Grid>
            </Grid>
            <br/>
            <div>
                <Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleClose}>
                    <Alert onClose={handleClose} severity="error" sx={{width: '100%'}}>
                        {t('simulation_page.please_check_your_input_values')}
                    </Alert>
                </Snackbar>
            </div>
            {
                error && errorMessage &&  <div>
                    <Snackbar
                        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                        open={snackbarOpen}
                        autoHideDuration={6000}
                        onClose={handleClose}>
                        <Alert onClose={handleClose} severity="error" sx={{width: '100%'}}>
                            {errorMessage}
                        </Alert>
                    </Snackbar>
                </div>
            }

        </React.Fragment>
    )
}
export default SendRequestForm
